exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-class[data-v-98c8e8f2] {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n.select-with[data-v-98c8e8f2] {\n    width: 28%;\n}\n.button-width[data-v-98c8e8f2] {\n    width: 16%;\n    float: right;\n}\ndiv#table[data-v-98c8e8f2] {\n    white-space: nowrap;\n}\n", ""]);

// exports
